import React, { useState, useEffect } from "react";
import axios from "axios";
import Sidebar from "./AdminComp/Sidebar";
import BreadCrumb from "./AdminComp/BreadCrumb";
import { baseurl } from "../../component/Baseurl"; 
import Swal from "sweetalert2";


function AdminMarkup() { 
  const adminId = localStorage.getItem("adminId");

  const [markupData, setMarkupData] = useState({
    flight_markup: "",
    hotel_markup: "",
    bus_markup: "",
    recharge_markup: "",
    agent_flight_markup: "",
    agent_hotel_markup: "",
    agent_bus_markup: "",
    agent_recharge_markup: "",
  });

  const [loading, setLoading] = useState(true); // Loader state

  // Fetch existing markup values
  useEffect(() => {
    const fetchMarkup = async () => {
      try {
        const response = await axios.get(`${baseurl}getAdminMarkup/${adminId}`);
        const { flight_markup, hotel_markup, bus_markup, recharge_markup,agent_flight_markup,
          agent_hotel_markup, agent_bus_markup, agent_recharge_markup
         } = response.data.markup;
        setMarkupData({ flight_markup, hotel_markup, bus_markup, recharge_markup,agent_flight_markup,
          agent_hotel_markup, agent_bus_markup, agent_recharge_markup
          });
      } catch (error) {
        console.error("Error fetching markup data:", error);
      } finally {
        setLoading(false); // Hide loader after fetching
      }
    };

    if (adminId) {
      fetchMarkup();
    }
  }, [adminId]);

  // Handle form input changes
  const handleChange = (e) => {
    setMarkupData({ ...markupData, [e.target.name]: e.target.value });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
  
    try {
      await axios.put(`${baseurl}updateAdminmarkup/${adminId}`, markupData);
      
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Markup updated successfully!",
      });
    } catch (error) {
      console.error("Error updating markup:", error);
      
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to update markup.",
      });
    }
  };

  return (
    <>
      <div className="App" style={{ display: "flex" }}>
        <Sidebar />
        {/* Content area */}
        <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
          <div>
            <BreadCrumb />
            <div className="container-fluid">
              <div className="crdmain mb-2">
                <div className="d-flex justify-content-between align-items-center" style={{ width: "100%" }}>
                  <h2 className="chart-title mb-0">Admin Markup</h2>
                  <div className="ms-auto"></div>
                </div>

                {loading ? (
                  // Show Loader
                  <div className="text-center mt-4">
                    <div className="loader1 text-center"> 
                    </div>
                  </div>
                ) : (
                  // Show Form after data is loaded
                  <div className="row g-2 mt-0 mb-0">
                    <div className="col-md-12 p-2">
                      <form onSubmit={handleSubmit}>
                        <div className="row g-1 text-start">
                          <div className="col-md-12 rtqq1">
                            <div className="row g-1">
                              {/* Flight Markup */}
                              <div className="col-md-3">
                                <label className="text-dark mb-1 labelset2 font3">Flight Markup</label>
                                <input 
                                  type="number" 
                                  className="input1" 
                                  placeholder="Enter here" 
                                  name="flight_markup" 
                                  value={markupData.flight_markup} 
                                  onChange={handleChange} 
                                />
                              </div>

                              {/* Hotel Markup */}
                              <div className="col-md-3">
                                <label className="text-dark mb-1 labelset2 font3">Hotel Markup</label>
                                <input 
                                  type="number" 
                                  className="input1" 
                                  placeholder="Enter here" 
                                  name="hotel_markup" 
                                  value={markupData.hotel_markup} 
                                  onChange={handleChange} 
                                />
                              </div>

                              {/* Bus Markup */}
                              <div className="col-md-3">
                                <label className="text-dark mb-1 labelset2 font3">Bus Markup</label>
                                <input 
                                  type="number" 
                                  className="input1" 
                                  placeholder="Enter here" 
                                  name="bus_markup" 
                                  value={markupData.bus_markup} 
                                  onChange={handleChange} 
                                />
                              </div>

                              {/* Recharge Markup */}
                              <div className="col-md-3">
                                <label className="text-dark mb-1 labelset2 font3">Recharge Markup</label>
                                <input 
                                  type="number" 
                                  className="input1" 
                                  placeholder="Enter here" 
                                  name="recharge_markup" 
                                  value={markupData.recharge_markup} 
                                  onChange={handleChange} 
                                />
                              </div>






                              {/* Flight Markup */}
                              <div className="col-md-3">
                                <label className="text-dark mb-1 labelset2 font3">Agent Flight Markup</label>
                                <input 
                                  type="number" 
                                  className="input1" 
                                  placeholder="Enter here" 
                                  name="agent_flight_markup" 
                                  value={markupData.agent_flight_markup} 
                                  onChange={handleChange} 
                                />
                              </div>

                              {/* Hotel Markup */}
                              <div className="col-md-3">
                                <label className="text-dark mb-1 labelset2 font3">Agent Hotel Markup</label>
                                <input 
                                  type="number" 
                                  className="input1" 
                                  placeholder="Enter here" 
                                  name="agent_hotel_markup" 
                                  value={markupData.agent_hotel_markup} 
                                  onChange={handleChange} 
                                />
                              </div>

                              {/* Bus Markup */}
                              <div className="col-md-3">
                                <label className="text-dark mb-1 labelset2 font3">Agent Bus Markup</label>
                                <input 
                                  type="number" 
                                  className="input1" 
                                  placeholder="Enter here" 
                                  name="agent_bus_markup" 
                                  value={markupData.agent_bus_markup} 
                                  onChange={handleChange} 
                                />
                              </div>

                              {/* Recharge Markup */}
                              <div className="col-md-3">
                                <label className="text-dark mb-1 labelset2 font3">Agent Recharge Markup</label>
                                <input 
                                  type="number" 
                                  className="input1" 
                                  placeholder="Enter here" 
                                  name="agent_recharge_markup" 
                                  value={markupData.agent_recharge_markup} 
                                  onChange={handleChange} 
                                />
                              </div>



                            </div>
                          </div>
                        </div>

                        {/* Submit Button */}
                        <div className="text-end">
                          <button type="submit" className="submit-btn mt-3">Update</button>
                        </div>
                      </form>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div> 
    </>
  );
}

export default AdminMarkup;
